<template>
  <div class="chip-label">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'ChipLabel',
  };
</script>

<style lang="scss" scoped>
  .chip-label {
    background-color: $color--red-1;
    border-radius: 15px;
    color: $color--white;
    padding: 0 15px;
    margin: 18px 0 10px;
    text-transform: uppercase;
    text-align: center;
    display: inline-block;
    font-weight: $weight-semibold;
    @include fontSize(15px);
  }
</style>
